/**
 * Hub usage stats (Sep 2026) — AGGREGATED ONLY (Michael's decision: no
 * per-person view). The client pings once per app per 30 min per tab; the
 * server keeps counters per day and a per-day / per-month set of SALTED
 * HASHES (monthly salt, server-only) purely to count distinct users. The
 * nightly rollup turns those sets into counts and deletes them: day sets live
 * ≤ 1 day, month sets ≤ 1 month. No emails, no per-person rows are ever read
 * back by the UI.
 */
import { z } from 'zod';
export const HubUsagePingSchema = z.object({
    /** First path segment ('' = Home), e.g. 'expenses', 'absence', 'analytics'. */
    app: z.string().trim().max(40).regex(/^[a-z0-9-]*$/),
    device: z.enum(['phone', 'tablet', 'desktop']),
    mode: z.enum(['app', 'browser']),
});
/** Engagement batch (Sep 2026): finished page visits + sessions started, flushed by the client. */
export const HubUsageEngagementSchema = z.object({
    items: z.array(z.object({
        /** Normalised route, ids stripped, '~' as separator (e.g. 'expenses~statements~:id'). */
        page: z.string().trim().min(1).max(80).regex(/^[a-z0-9:~-]+$/),
        seconds: z.number().int().min(0).max(4 * 3600),
        /** Max scroll depth 0-100, or null when the page did not scroll (fits the screen). */
        scroll: z.number().int().min(0).max(100).nullable(),
    })).max(40),
    sessions: z.number().int().min(0).max(10),
});
export const HubUsageSummarySchema = z.object({
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
//# sourceMappingURL=hubUsage.js.map